import React, { FC, ReactNode } from "react";

import styles from "./index.module.css";

type CenterProps = {
  children: ReactNode;
};

const Center: FC<CenterProps> = (props) => {
  const { children } = props;
  return <div className={styles.container}>{children}</div>;
};

export default Center;
